// @owners { team: patients-team }
import { Body, Button, Card, Illustration, LgPadding, MdSpacing, Row } from '@alto/design-system';
import React from 'react';

type Props = {
  readonly buttonText: string;
  readonly img: string;
  readonly text: string;
  readonly onClick: () => void;
  readonly imgAlt: string;
  readonly inline?: boolean;
};

export const SidebarItem = ({ buttonText, img, onClick, text, imgAlt, inline = false }: Props) => {
  return (
    <Card>
      <LgPadding>
        <Row center>
          <Illustration
            source={img}
            accessibilityLabel={imgAlt}
            size="md"
          />
        </Row>
        <MdSpacing />
        <Body center>{text}</Body>
        <MdSpacing />
        {inline ? (
          <Row center>
            <Button
              label={buttonText}
              accessibilityLabel={buttonText}
              onPress={onClick}
              type="secondary"
              small
            />
          </Row>
        ) : (
          <Button
            label={buttonText}
            accessibilityLabel={buttonText}
            onPress={onClick}
            type="secondary"
            small
          />
        )}
      </LgPadding>
    </Card>
  );
};
